import { render, staticRenderFns } from "./KwtInput.vue?vue&type=template&id=2d7bf1e8&scoped=true&"
import script from "./KwtInput.vue?vue&type=script&lang=js&"
export * from "./KwtInput.vue?vue&type=script&lang=js&"
import style0 from "./KwtInput.vue?vue&type=style&index=0&id=2d7bf1e8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d7bf1e8",
  null
  
)

export default component.exports